import React, { useEffect, useState } from 'react';
import TextInput from '../../../../Shared/TextInput/TextInput';
import { validateValue } from '../../../../../utilities/validation/validator';
import { validationRules } from '../../../../../utilities/validation/validationVariables';
import '../AddressForm/addressForm.scss';

const formErrorMessages = {
  identity: 'צריך להזין מספר תעודת זהות בן 9 ספרות',
  firstName: 'צריך להזין שם פרטי',
  lastName: 'צריך להזין שם משפחה',
  phoneNumber: 'צריך להזין מספר טלפון נייד',
};

const InternetCustomerInfoForm = (props) => {
  const [form, setForm] = useState({
    identity: { value: '', error: '' },
    firstName: { value: props.firstName ?? '', error: '' },
    lastName: { value: props.lastName ?? '', error: '' },
    phoneNumber: { value: props.phoneNumber ?? '', error: '' },
  });

  useEffect(() => {
    if (props.isSubmit) {
      submit();
    }
  }, [props.isSubmit]);

  function validateNameValue(value, emptyMessage) {
    const trimmedValue = value?.trim() ?? '';
    if (!trimmedValue) {
      return emptyMessage;
    }
    const name = /^[א-תA-Za-z ."״()-/\'/׳]+$/;
    if (!name.test(trimmedValue)) {
      return 'נא להזין ערך תקין';
    }
    return '';
  }

  function getIdentityError(value) {
    const trimmedValue = value?.trim() ?? '';
    if (!trimmedValue) {
      return formErrorMessages.identity;
    }
    const validationError = validateValue(validationRules.id, 'identity', trimmedValue);
    return validationError ? formErrorMessages.identity : '';
  }

  function getPhoneError(phoneNumber) {
    const trimmedPhone = phoneNumber?.trim() ?? '';
    if (!trimmedPhone || validateValue(validationRules.phone, 'phone', trimmedPhone)) {
      return formErrorMessages.phoneNumber;
    }
    return '';
  }

  function updateField(field, value, error) {
    setForm((prev) => ({
      ...prev,
      [field]: { value, error },
    }));
  }

  function checkIsValid() {
    let isValid = true;
    const nextForm = { ...form };

    const identityError = getIdentityError(form.identity.value);
    if (identityError) {
      isValid = false;
      nextForm.identity = { ...form.identity, error: identityError };
    }

    const firstNameError = validateNameValue(form.firstName.value, formErrorMessages.firstName);
    if (firstNameError) {
      isValid = false;
      nextForm.firstName = { ...form.firstName, error: firstNameError };
    }

    const lastNameError = validateNameValue(form.lastName.value, formErrorMessages.lastName);
    if (lastNameError) {
      isValid = false;
      nextForm.lastName = { ...form.lastName, error: lastNameError };
    }

    const phoneError = getPhoneError(form.phoneNumber.value);
    if (phoneError) {
      isValid = false;
      nextForm.phoneNumber = { ...form.phoneNumber, error: phoneError };
    }

    setForm(nextForm);
    return isValid;
  }

  function submit() {
    const isValid = checkIsValid();
    props.onSubmit({
      isValid,
      data: {
        identity: form.identity.value?.trim(),
        firstName: form.firstName.value?.trim(),
        lastName: form.lastName.value?.trim(),
        phoneNumber: form.phoneNumber.value?.trim(),
      },
    });
  }

  return (
    <div className='address-sale-block'>
      <div className='address-wrapper'>
        <div className='form-wrapper'>
          <div className='row-wrapper'>
            <TextInput
              value={form.identity.value}
              error={form.identity.error}
              placeholder='תעודת זהות'
              id='identity'
              name='identity'
              maxLength='9'
              type='text'
              autoComplete='off'
              onChange={(e) => updateField('identity', e.target.value, '')}
              required='required'
            />
          </div>
          <div className='row-wrapper'>
            <TextInput
              value={form.firstName.value}
              error={form.firstName.error}
              placeholder='שם פרטי'
              id='firstName'
              name='firstName'
              maxLength='50'
              type='text'
              autoComplete='given-name'
              onChange={(e) => updateField('firstName', e.target.value, '')}
              required='required'
            />
          </div>
          <div className='row-wrapper'>
            <TextInput
              value={form.lastName.value}
              error={form.lastName.error}
              placeholder='שם משפחה'
              id='lastName'
              name='lastName'
              maxLength='50'
              type='text'
              autoComplete='family-name'
              onChange={(e) => updateField('lastName', e.target.value, '')}
              required='required'
            />
          </div>
          <div className='row-wrapper'>
            <TextInput
              value={form.phoneNumber.value}
              error={form.phoneNumber.error}
              placeholder='מספר טלפון'
              id='phoneNumber'
              name='phoneNumber'
              maxLength='10'
              type='tel'
              autoComplete='tel'
              onChange={(e) => updateField('phoneNumber', e.target.value, '')}
              required='required'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternetCustomerInfoForm;
